import { Chip, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";

const GrayChip = ({ text }) => {
  const colors = useColors();
  return (
    <Chip
      label={<Typography variant="caption">{text}</Typography>}
      sx={{
        backgroundColor: colors.grey_12percent,
        color: colors.text_secondary,
        borderRadius: "8px",
        height: "30px ",
      }}
    ></Chip>
  );
};

export default GrayChip;
